export default __webpack_public_path__ + "static/media/udemy3.d2284415.png";